export {
  default,
  getServerSideProps,
} from '@/views/Auth/pages/b2b-login-v2/b2b-login-v2';
